import { render, staticRenderFns } from "./CreateNewGroupDialog.vue?vue&type=template&id=5d187b6b&scoped=true"
import script from "./CreateNewGroupDialog.vue?vue&type=script&lang=js"
export * from "./CreateNewGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateNewGroupDialog.vue?vue&type=style&index=0&id=5d187b6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d187b6b",
  null
  
)

export default component.exports